import type { Severity } from "../lib/types";

function toLabel(text: string): string {
  const lower = text.trim().toLowerCase();
  if (lower === "out_of_stock") return "Out of Stock";
  if (lower === "expiring_90d") return "Expiring ≤ 90 Days";
  if (lower === "backorder") return "Backorder";
  if (lower === "expired") return "Expired";
  if (lower === "missing") return "Missing";
  return text
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function StatusBadge({ severity, text }: { severity: Severity; text?: string | null }) {
  if (severity === "ok" && !text) return null;
  const label = text ? toLabel(text) : severity === "red" ? "Red" : severity === "yellow" ? "Yellow" : "OK";
  return <span className={`status-badge status-${severity}`}>{label}</span>;
}
